import React, { useState, useRef, useContext, useEffect } from "react";
import { Modal, ModalBody } from "reactstrap";
import { addCart } from "../helper/backend-methods";
import { customToast } from "./customToast";
import { GlobalContext } from "../context";
import menu from "../assets/images/mains-logo.png";
import "../assets/css/--component-cart.css";
import "../assets/css/--component-checkout.css";
import { useCart } from "../context/cartProvider";

function ProductCustomizationModal({ isOpen, onClose, product, toastLink = "/openCart" }) {
  const { openCart } = useCart();
  const { updateCartCount, updateCartDrawer } = useContext(GlobalContext);
  const [selectedItem, setSelectedItem] = useState(product);
  const [quantities, setQuantities] = useState({ [product?.ProductId]: 1 });
  const [activeTab, setActiveTab] = useState("custom");
  const [selectedCustomization, setSelectedCustomization] = useState([]);
  const customRef = useRef(null);
  const addonsRef = useRef(null);
  const [note, setNote] = useState("");

  useEffect(() => {
    if (product) {
      const item = { ...product };
      item.SelectedAddons = [];
      item.totalPrice = getSelectedItemPrice(item);
      setSelectedItem(item);
      setQuantities({ [product.ProductId]: 1 });
      setSelectedCustomization([]);
      setActiveTab(product.productAttributes.find((attr) => attr.IsRequired == true) ? "custom" : "addons");
    }
  }, [product]);

  const scrollToCustom = () => {
    setActiveTab("custom");
    // Optional: Keep scroll if you want smooth scrolling
    // customRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToAddons = () => {
    setActiveTab("addons");
    // Optional: Keep scroll if you want smooth scrolling
    // addonsRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const increaseQty = (id) => {
    setQuantities((prev) => ({
      ...prev,
      [id]: (prev[id] || 1) + 1,
    }));
  };

  const decreaseQty = (id) => {
    setQuantities((prev) => {
      const newQty = (prev[id] || 0) - 1;
      if (newQty <= 0) {
        const copy = { ...prev };
        delete copy[id];
        return copy;
      }
      return { ...prev, [id]: newQty };
    });
  };

  const getSelectedItemPrice = (item) => {
    let totalPrice = item.Price || 0;
    if (item.SelectedAddons && item.SelectedAddons.length > 0) {
      item.SelectedAddons.forEach((addon) => {
        totalPrice += addon.PriceAdjustment || 0;
      });
    }
    return totalPrice;
  };

  const handleModalAddToCart = () => {
    try {
      if (selectedItem) {
        addCart({
          Products: [
            {
              ProductId: selectedItem.Id || selectedItem.ProductId,
              Quantity: quantities[selectedItem.Id || selectedItem.ProductId] || 1,
              AttributesXml: createAttributeXml(selectedItem),
              AttributesDescription: note,
            },
          ],
        }).then(({ data }) => {
          if (data.Status) {
            customToast.success("Added to Cart", "Your selected item has been successfully added.", toastLink);
            updateCartCount({
              CartItemCount: data.Data.CartItemCount,
              TotalAmount: data.Data.TotalAmount,
            });
            updateCartDrawer();
            handleClose();
          }
        });
      }
    } catch (error) {
      console.error("Error adding to cart:", error);
    }
  };

  const createAttributeXml = (item) => {
    if (item.SelectedAddons && item.SelectedAddons.length > 0) {
      let xml = "<Attributes>";
      item.SelectedAddons.forEach((addons) => {
        xml += `<ProductAttribute ID='${addons.ProductAttributeMappingId}'>`;
        xml += "<ProductAttributeValue>";
        xml += `<Value>${addons.Id}</Value>`;
        xml += "</ProductAttributeValue>";
        xml += "</ProductAttribute>";
      });
      xml += "</Attributes>";
      return xml;
    }
    return null;
  };

  const setSelectedCustomizationorAddons = (attr) => {
    attr.isCustomize = false;
    const existingAddons = selectedItem.SelectedAddons || [];
    const isAlreadySelected = existingAddons.some((a) => a.Id === attr.Id);
    let updatedAddons;

    const isMatched = selectedItem.productAttributes.some(
      (p) => p.IsRequired && p.productAttributeValues?.some((v) => v.ProductAttributeMappingId === attr.ProductAttributeMappingId),
    );

    if (isMatched) {
      const isAlreadySelected = selectedItem.SelectedAddons?.some((a) => a.ProductAttributeMappingId === attr.ProductAttributeMappingId);

      if (isAlreadySelected) {
        updatedAddons = existingAddons.filter((a) => a.ProductAttributeMappingId !== attr.ProductAttributeMappingId);
        selectedItem.SelectedAddons = updatedAddons;
        attr.isCustomize = true;
        selectedItem.SelectedAddons.push(attr);
      } else {
        attr.isCustomize = true;
        selectedItem.SelectedAddons.push(attr);
      }

      selectedItem.totalPrice = getSelectedItemPrice(selectedItem);
      setSelectedItem({ ...selectedItem });
      setSelectedCustomization(selectedItem.SelectedAddons.filter((s) => s.isCustomize == true));
      return;
    }

    if (isAlreadySelected) {
      updatedAddons = existingAddons.filter((a) => a.Id !== attr.Id);
    } else {
      updatedAddons = [...existingAddons, attr];
    }

    selectedItem.SelectedAddons = updatedAddons;
    selectedItem.totalPrice = getSelectedItemPrice(selectedItem);
    setSelectedItem({ ...selectedItem });
  };

  const getItemCustomizationAndAddOns = (item) => {
    if (!item || !item.productAttributes || !Array.isArray(item.productAttributes)) {
      return { customizations: [], addOns: [] };
    }
    const customizations = item.productAttributes.filter((attr) => attr.IsRequired == true);
    const addOns = item.productAttributes.filter((attr) => attr.IsRequired == false);
    return { customizations, addOns };
  };

  const handleClose = () => {
    setSelectedCustomization([]);
    if (selectedItem) {
      selectedItem.SelectedAddons = [];
      selectedItem.totalPrice = getSelectedItemPrice(selectedItem);
    }
    setNote("");
    onClose();
  };

  if (!selectedItem) return null;

  const productId = selectedItem.ProductId || selectedItem.Id;
  const { customizations, addOns } = getItemCustomizationAndAddOns(selectedItem);

  return (
    <Modal isOpen={isOpen} toggle={handleClose} className="menu-detail-modal" size="lg" centered>
      <ModalBody className="menu-detail-body">
        <button className="detail-close" onClick={handleClose}>
          ✕
        </button>

        {selectedItem && (
          <>
            {/* HEADER */}
            <div className="detail-header">
              <img src={selectedItem?.ProductPictures[0]?.Url} alt={selectedItem.ProductName || selectedItem.Name} />
              <div className="mains-detail">
                <h2 className="heading">{selectedItem.ProductName || selectedItem.Name}</h2>
                {/* <p className="dis">{selectedItem.ShortDescription}</p> */}
                <p className="dis" title={selectedItem?.ShortDescription || ""}>
                  {selectedItem?.ShortDescription
                    ? selectedItem.ShortDescription.length > 140
                      ? selectedItem.ShortDescription.slice(0, 140) + "..."
                      : selectedItem.ShortDescription
                    : ""}
                </p>
                <h3 className="price">${selectedItem.Price?.toFixed(2)}</h3>
              </div>
            </div>

            {/* TABS */}
            <div className="detail-tabs">
              {customizations.length > 0 && (
                <button className={activeTab === "custom" ? "active" : ""} onClick={scrollToCustom}>
                  CUSTOMIZATIONS
                </button>
              )}
              {addOns.length > 0 && (
                <button className={activeTab === "addons" ? "active" : ""} onClick={scrollToAddons}>
                  ADD ONS
                </button>
              )}
            </div>

            <div className="mains-tabs-container">
              {/* Show Customizations only when activeTab is "custom" */}
              {activeTab === "custom" && customizations.length > 0 && (
                <div className="customization-content" ref={customRef}>
                  {customizations.map((attr) => (
                    <div key={attr.AttributeName} className="detail-section">
                      <div className="section-title">
                        {attr.TextPrompt || attr.AttributeName}
                        {attr.IsRequired && <span className="required">*</span>}
                      </div>
                      {attr.productAttributeValues.map((value) => (
                        <label key={value.Id} className="option-item">
                          <input
                            type="radio"
                            name={attr.AttributeName}
                            onChange={() => setSelectedCustomizationorAddons(value)}
                            value={value.Id}
                            checked={selectedItem.SelectedAddons?.some(
                              (addon) => addon.Id === value.Id && addon.ProductAttributeMappingId === value.ProductAttributeMappingId,
                            )}
                          />
                          <span className="custom-radio"></span>
                          <span className="option-text">{value.Name}</span>
                          <span className="option-price">${value.Cost.toFixed(2)}</span>
                        </label>
                      ))}
                    </div>
                  ))}
                </div>
              )}

              {/* Show Add-ons only when activeTab is "addons" */}
              {activeTab === "addons" && addOns.length > 0 && (
                <div className="addons-content" ref={addonsRef}>
                  {addOns.map((attr) => (
                    <div key={attr.AttributeName} className="detail-section">
                      <div className="section-title">{attr.TextPrompt || attr.AttributeName}</div>
                      {attr.productAttributeValues.map((value) => (
                        <label key={value.Id} className="option-item">
                          <input
                            type="checkbox"
                            name="attr"
                            onChange={() => setSelectedCustomizationorAddons(value)}
                            checked={selectedItem.SelectedAddons?.some((addon) => addon.Id === value.Id)}
                          />
                          <span className="custom-checkbox"></span>
                          <span className="option-text">{value.Name}</span>
                          <span className="option-price">+${value.Cost.toFixed(2)}</span>
                        </label>
                      ))}
                    </div>
                  ))}
                </div>
              )}
            </div>
            {/* Special Instructions / Note */}
            <div className="detail-section">
              <div className="instruction-title">Special Instructions (Optional)</div>
              <textarea
                name="orderNotes"
                value={note}
                onChange={(e) => setNote(e.target.value)}
                placeholder="Add a note for our kitchen..."
                rows="3"
                maxLength="500"
                style={{
                  width: "100%",
                  padding: "12px",
                  border: "1px solid #d6d5d5",
                  borderRadius: "5px",
                  fontSize: "14px",
                  color: "#393939",
                  backgroundColor: "#fff",
                  outline: "none",
                  resize: "vertical",
                  fontFamily: "inherit",
                }}
              />
            </div>

            <div className="detail-footer">
              <div className="qty-control">
                <button onClick={() => decreaseQty(productId)}>-</button>
                <span>{quantities[productId] || 1}</span>
                <button onClick={() => increaseQty(productId)}>+</button>
              </div>

              <button
                className={`add-cart-btn ${customizations.length > 0 && selectedCustomization.length !== customizations.length ? "disable-cart-btn" : ""}`}
                onClick={handleModalAddToCart}
                disabled={customizations.length > 0 && (!selectedCustomization || selectedCustomization.length !== customizations.length)}
              >
                ADD TO CART ${(selectedItem.totalPrice * (quantities[productId] || 1)).toFixed(2)}
              </button>
            </div>

            {selectedCustomization.length !== customizations.length ? (
              <div className="detail-section" style={{ color: "red", textAlign: "center" }}>
                Please select at least one from all customization options to proceed.
              </div>
            ) : (
              <div></div>
            )}
          </>
        )}
      </ModalBody>
    </Modal>
  );
}

export default ProductCustomizationModal;
